<template>
  <div v-if="entity.id && dataReady">
    <aru-auto-form
      v-if="!!formConfig"
      v-model="checklistForm"
      :validate-before-submit="validateBeforeSubmit"
      :key="entity.id"
      :form-configuration="formConfig"
      :submit-text="$t('Guardar')"
      dismiss-button
      :dismiss-text="$t('Atrás')"
      show-header-actions
      :saving-data="savingData"
      @dismiss="goBack"
      @submit="updateChecklist"
      @validationErrors="checklistErrors"
    ></aru-auto-form>
  </div>
</template>

<script>
import AruAutoForm from '@/components/commons/form/AruAutoForm.vue';
import apiCtrl from '@/services/aru-services/aru-api.service.js';

export default {
  components: {
    AruAutoForm,
  },
  props: {
    entity: {
      type: Object,
    },
    formConfig: {
      type: Object,
    },
    validateBeforeSubmit: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      checklistForm: {},
      savingData: false,
      dataReady: false,
    };
  },
  mounted() {
    if (!this.checkEntity()) {
      this.$router.push('/opendata/form/wellcome');
    }
    this.setChecklistForm();
  },

  methods: {
    checkEntity() {
      if (
        !!this.entity &&
        this.entity.hasOwnProperty('id') &&
        this.entity.id &&
        this.entity.status === 'validated'
      ) {
        return true;
      }

      return false;
    },
    setChecklistForm() {
      this.dataReady = false;

      if (!!this.entity && this.entity.hasOwnProperty('checklist') && !!this.entity.checklist) {
        console.log('HAS ENTITY');
        for (const key in this.entity.checklist) {
          if (this.entity.checklist.hasOwnProperty(key)) {
            const value = this.entity.checklist[key];
            console.log({ key: key, value: value });
            this.$set(this.checklistForm, key, value);
          }
        }
        this.dataReady = true;
      } else {
        this.checklistForm = {};
        this.dataReady = true;
      }
    },
    goBack() {
      this.$router.push('/opendata/form/wellcome');
    },
    updateChecklist(data) {
      this.savingData = true;
      this.checklistForm = data;
      const entityData = {
        ...this.entity,
      };
      entityData['checklist'] = this.checklistForm;

      console.log({ entityData: entityData });

      apiCtrl
        .put('/opendata-form/' + this.entity.id, entityData)
        .then(res => {
          this.savingData = false;
          this.$router.push('/opendata/form/wellcome');
        })
        .catch(err => {
          this.savingData = false;
        });
    },
    checklistErrors(err) {
      console.log(err);
    },
  },
};
</script>

<style></style>
